import { Link } from "react-router-dom";
import { Seo } from "../components/site/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Not Found" />
      <section className="min-h-[80vh] flex flex-col items-center justify-center text-center px-6">
        <p className="eyebrow mb-6">404</p>
        <h1 className="display text-7xl lg:text-9xl text-white">Off the map.</h1>
        <p className="mt-6 text-[#9E9EA8] max-w-md">This page doesn't exist — but the work does.</p>
        <div className="mt-10 flex gap-4">
          <Link to="/" className="border border-ash text-white font-mono text-xs uppercase tracking-[0.2em] px-8 py-4 hover:border-white transition-colors">Home</Link>
          <Link to="/booking" className="bg-ember text-obsidian font-mono text-xs uppercase tracking-[0.2em] font-semibold px-8 py-4 hover:bg-white transition-colors">Book</Link>
        </div>
      </section>
    </>
  );
}
